import { isEnumValid } from '@philips-emr/tws-utils';

import { TypeChecker, withInfo, wrapCreator } from './util';

type IntellisenseFunction = (typeChecker: TypeChecker, expectedType: IntellisenseExpectedType) => TypeChecker;
enum IntellisenseExpectedType {
  ANY = 'Any',
  EXPRESSION = 'Expression',
  URL = 'URL',
}

const unworthyOfBeingPlaceholder = [
  IntellisenseExpectedType.ANY,
];

const creator: IntellisenseFunction = (typeChecker, expectedType) => {
  if (!isEnumValid(IntellisenseExpectedType, expectedType)) {
    throw new Error('[Intellisense]: The prop-type definition should provide the expected type as the second parameter.');
  }

  const type = withInfo(typeChecker, { expectedType });

  if (unworthyOfBeingPlaceholder.includes(expectedType)) {
    return type;
  }
  return type.placeholder(expectedType.toLowerCase());
};

const intellisense = wrapCreator(creator, { type: 'intellisense' }, false) as IntellisenseFunction;

export {
  IntellisenseExpectedType,
  IntellisenseFunction,
  intellisense,
};
